// 章节
import request from '@/router/axios';

let urlPrefix = '/api/exam/etknowledgepoint';

/**
 * 编辑/新增章节
 * @param {Object} data 章节信息
 * @param {Integer} data.pointId 章节pointId
 * @param {String} data.pointName 章节名称
 * @param {Integer} data.pid 父级章节pointId
 * @param {String} data.pids 父级章节pointId(从小到大排， 用','隔开)
 * @param {Integer} data.fieldId 所属题库fieldId
 * @param {Integer} data.state 章节状态   0 可用  1 不可用
 */
export const editKnowledgepoint = data => {
    const { pointId } = data;
    let type = pointId ? 'put' : 'post';
    return request(urlPrefix, { data }, type);
};

/**
 * 批量删除章节
 * @param {Array} data 章节pointId列表
 * @param {Integer} data[] 章节pointId
 */
export const delKnowledgepoint = data => {
    return request(`${urlPrefix}/deleteBatch`, { data }, 'delete');
};

/**
 * 获取题库下的章节树结构
 * @param {String} filedId 题库id
 */
export const getEtknowledgepointTree = filedId => {
    return request(`${urlPrefix}/select`, { params: { filedId } });
};

/**
 * 获取章节下各题目数量
 */
export const getNowTopicNumber = data => {
    return request(`${urlPrefix}/getQuestionNum`, { data }, 'post');
};